module.exports = __webpack_public_path__ + "media/service_features/e_i-e8d39a53.png";